<div class="form-group" [ngClass]="{'row': horizontal}">
    <label for="InputFechaEntrega" [ngClass]="{'col-4 col-form-label text-md-right': horizontal}">{{label}}</label>
    <div class="input-group"
        [ngClass]="{'input-group-lg': size === 'lg','input-group-sm': size === 'sm', 'col-8': horizontal}">
        <div class="input-group-prepend" *ngIf="!hideIcon || !activateButton">
            <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
        </div>

        <div class="input-group-prepend" *ngIf="activateButton">
            <button class="btn btn-outline-primary btn-block" (click)="sumarDias(-1)"><i
                    class="fas fa-chevron-left"></i></button>
        </div>
        <ng-container [ngTemplateOutlet]="withTime ? templateWithTime : templateWithOutTime"></ng-container>
        <div class="input-group-append" *ngIf="activateButton">
            <button class="btn btn-outline-primary btn-block" (click)="sumarDias(1)"><i
                    class="fas fa-chevron-right"></i></button>
        </div>
    </div>
</div>

<ng-template #templateWithOutTime>
    <input type="text" class="form-control {{cssClass}} {{ readOnly ? 'readonly-look' : ''}}" [ngClass]="size == '' ? '' : 'form-control-'+ size"
        bsDatepicker [(ngModel)]="bsValue" [id]="idForm" [minDate]="minDate" [maxDate]="maxDate"
        [placeholder]="placeholder" autocomplete="off" [isDisabled]="isDisabled" [bsConfig]="{   
            isAnimated: true, 
            dateInputFormat: 'DD/MM/YYYY', 
            containerClass: 'theme-dark-blue',  
            returnFocusToInput: true 
        }" (bsValueChange)="onValueChange($event)"
        (keydown)="readOnly && $event.preventDefault()"
        (paste)="readOnly && $event.preventDefault()"
        (drop)="readOnly && $event.preventDefault()"
        (focus)="readOnly && $event.target.blur()">
</ng-template>

<ng-template #templateWithTime>
    <input type="text" class="form-control {{cssClass}} {{ readOnly ? 'readonly-look' : ''}}" [ngClass]="size == '' ? '' : 'form-control-'+ size"
        bsDatepicker [(ngModel)]="bsValue" [id]="idForm" [minDate]="minDate" [maxDate]="maxDate"
        [placeholder]="placeholder" autocomplete="off" [isDisabled]="isDisabled" [bsConfig]="{ 
            withTimepicker: true, 
            keepDatepickerOpened: true, 
            isAnimated: true, 
            rangeInputFormat: 'DD/MM/YYYY H:mm', 
            dateInputFormat: 'DD/MM/YYYY H:mm', 
            containerClass: 'theme-dark-blue',
            returnFocusToInput: true
        }" (bsValueChange)="onValueChange($event)" 
        (keydown)="readOnly && $event.preventDefault()"
        (paste)="readOnly && $event.preventDefault()"
        (drop)="readOnly && $event.preventDefault()"
        (focus)="readOnly && $event.target.blur()">
</ng-template>